import { render, staticRenderFns } from "./MyBA.vue?vue&type=template&id=1af32250&scoped=true&"
import script from "./MyBA.vue?vue&type=script&lang=js&"
export * from "./MyBA.vue?vue&type=script&lang=js&"
import style0 from "./MyBA.vue?vue&type=style&index=0&id=1af32250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af32250",
  null
  
)

export default component.exports